import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// import { FormsModule } from '@angular/forms';
import { WebcamModule } from 'ngx-webcam';

import { DialogConfirmComponent } from './common/components/dialogs/dialog-confirm/dialog-confirm.component';
import { DialogErrorComponent } from './common/components/dialogs/dialog-error/dialog-error.component';
import { DialogSuccessComponent } from './common/components/dialogs/dialog-success/dialog-success.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CameraComponent } from './common/components/camera/camera.component';
// import { StyleguideCameraComponent } from './extra/styleguide-camera/styleguide-camera.component';
import { SelfieComponent } from './selfie/selfie.component';
import { TokenInterceptor } from './shared/services/common/interceptors/token.interceptor';
import { LoaderInterceptor } from './shared/services/common/interceptors/loader.interceptor';

@NgModule({
	declarations: [
		AppComponent,
		DialogConfirmComponent,
		DialogErrorComponent,
		DialogSuccessComponent,
		CameraComponent,
		// StyleguideCameraComponent,
		SelfieComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		// NgbModule,
		// FormsModule,
		HttpClientModule,
		WebcamModule,
	],
	exports: [
		// FormsModule,
		// NgbModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
